import { Language } from "../../../Loc/Language";
import Loc from "../../../Loc/Loc";
import "./LanguageSelector.css" 

interface LanguageSelectorProps {
    setLanguage: (language: Language) => void;
    color: string;
}

export default function LanguageSelector (props: LanguageSelectorProps) {

    const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const button: HTMLButtonElement = event.currentTarget;
        Loc.changeLanguage(button.value);
        props.setLanguage(Loc.trad());
    }


    function define_color(currentLanguage: string, language: string) {
        if (currentLanguage === language) {
            return (props.color);
        }
        return ("darkgrey");
    }

    return (
        <div>
            <button className="btnLang" style={{ color: define_color(localStorage.getItem('language') || "en", "en")}} onClick={onClick} value="en">EN</button>
            |
            <button className="btnLang" style={{ color: define_color(localStorage.getItem('language') || "en", "fr")}} onClick={onClick} value="fr">FR</button>
        </div>
    )
}